import Text from "components/Text";
import { FC, useState } from "react";
import { BiUser } from "react-icons/bi";
import { CgCardSpades } from "react-icons/cg";
import { IoImageOutline, IoLanguageOutline } from "react-icons/io5";
import { RiSuitcaseLine } from "react-icons/ri";
import ExperienceAndWork from "./ExperienceAndWork";
import { InfoTabsWrapper, Tab, Tabs } from "./InfoTabs.styled";
import LocationAndLanguage from "./LocationAndLanguage";
import OtherInterest from "./OtherInterest";
import PersonalInfo from "./PersonalInfo";
import PhotosAndVideos from "./PhotosAndVideos";
import PhysicalDetails from "./PhysicalDetails";

export const InfoTabs: FC = () => {
    const [selectedTab, setSelectedTab] = useState("");

    const handleTabSelection = (tab: string) => {
        if (tab === selectedTab) {
            setSelectedTab("");
        } else {
            setSelectedTab(tab);
        }
    };
    return (
        <InfoTabsWrapper>
            <Tabs>
                <Tab
                    isSelected={selectedTab === "Personal Info"}
                    onClick={() => handleTabSelection("Personal Info")}
                >
                    <BiUser />
                    <Text variant="label">Personal Info</Text>
                </Tab>
                <Tab
                    isSelected={selectedTab === "Photos and Videos"}
                    onClick={() => handleTabSelection("Photos and Videos")}
                >
                    <IoImageOutline />
                    <Text variant="label">Photos and Videos</Text>
                </Tab>
                <Tab
                    isSelected={selectedTab === "Physical Details"}
                    onClick={() => handleTabSelection("Physical Details")}
                >
                    <IoImageOutline />
                    <Text variant="label">Physical Details</Text>
                </Tab>
                <Tab
                    isSelected={selectedTab === "Experience and Work"}
                    onClick={() => handleTabSelection("Experience and Work")}
                >
                    <RiSuitcaseLine />
                    <Text variant="label">Experience and Work</Text>
                </Tab>
                <Tab
                    isSelected={selectedTab === "Other Interests"}
                    onClick={() => handleTabSelection("Other Interests")}
                >
                    <CgCardSpades />
                    <Text variant="label">Other Interests</Text>
                </Tab>
                <Tab
                    isSelected={selectedTab === "Location and Language"}
                    onClick={() => handleTabSelection("Location and Language")}
                >
                    <IoLanguageOutline />
                    <Text variant="label">Location and Language</Text>
                </Tab>
            </Tabs>
            {(selectedTab === "Personal Info" || selectedTab === "") && (
                <PersonalInfo />
            )}
            {(selectedTab === "Photos and Videos" || selectedTab === "") && (
                <PhotosAndVideos />
            )}
            {(selectedTab === "Physical Details" || selectedTab === "") && (
                <PhysicalDetails />
            )}
            {(selectedTab === "Experience and Work" || selectedTab === "") && (
                <ExperienceAndWork />
            )}
            {(selectedTab === "Other Interests" || selectedTab === "") && (
                <OtherInterest />
            )}
            {(selectedTab === "Location and Language" ||
                selectedTab === "") && <LocationAndLanguage />}
        </InfoTabsWrapper>
    );
};
